<template>
  <fragment>
    <tr>
      <td>
        <strong>Desabilitar integração com QB?</strong>
      </td>
      <td>
        <checkbox-field
          label="Sim"
          v-model="form.get('integrationDisallowed').value"
          :errors="form.get('integrationDisallowed').errors"
          @input="emitFormFieldChanged('integrationDisallowed')"
        />
      </td>
    </tr>
  </fragment>
</template>
<script>
import { CheckboxField } from 'components/form';

export default {
  components: {
    CheckboxField,
  },
  props: {
    form: {
      type: Object,
      required: true,
    },
  },
  methods: {
    emitFormFieldChanged(field) {
      this.$emit('form-field-changed', { [field]: this.form.get(field).value });
    },
  },
};
</script>
